<template>
    <v-card flat>
        <v-card-text>
            <v-container
                :style="[
                    $vuetify.breakpoint.xs ? { 'padding-top': '0px' } : {},
                ]"
            >
                <v-row justify-center align-center>
                    <v-col
                        v-if="contentTab.sanityImage"
                        cols="12"
                        md="6"
                        class="contentTab--image"
                        :style="[
                            $vuetify.breakpoint.xs
                                ? {
                                      'background-color': 'white',
                                      'border-radius': '4px',
                                  }
                                : {},
                        ]"
                    >
                        <EmbedSanityImage
                            :selectedImage="
                                contentTab.sanityImage &&
                                contentTab.sanityImage.selectedImage
                            "
                            :alt="
                                contentTab.sanityImage &&
                                contentTab.sanityImage.alt[$i18n.locale]
                                    ? contentTab.sanityImage.alt
                                    : {
                                          en: 'c3controls image',
                                          es: 'c3controls image',
                                      }
                            "
                            width="600"
                            height="300"
                            fit="fill"
                        />
                    </v-col>
                    <v-col
                        v-if="
                            contentTab.blurbage &&
                            contentTab.blurbage[$i18n.locale]
                        "
                        cols="12"
                        md="6"
                        class="contentTab--content"
                    >
                        <h2>
                            {{
                                contentTab.heading &&
                                contentTab.heading[$i18n.locale]
                                    ? contentTab.heading[$i18n.locale]
                                    : 'Missing Data'
                            }}
                        </h2>
                        <Separator
                            steez="solid"
                            :color="
                                $vuetify.breakpoint.xs
                                    ? 'rgba(255, 255, 255, 0.7)'
                                    : ''
                            "
                        />
                        <BlockContent
                            :blocks="contentTab.blurbage[$i18n.locale]"
                            :serializers="serializers"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import Separator from '~/components/Separator'
import serializers from '~/util/sanity/serializers'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
export default {
    name: 'ContentMultiTabsSub',
    components: {
        Separator,
        EmbedCloudinary2,
        EmbedSanityImage,
    },
    props: {
        contentTab: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            serializers,
        }
    },
}
</script>
